var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.5,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    className: "social-link-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 42.989 21.494 C 42.989 31.124 36.669 39.27 27.943 42 L 27.943 36.54 C 27.943 34.703 27.169 33.058 25.944 31.876 C 31.575 30.855 34.391 27.577 34.391 21.494 C 34.391 18.861 33.854 16.776 32.8 15.154 C 33.273 13.316 33.553 10.704 32.242 8.598 C 29.705 8.598 27.932 10.092 26.889 11.317 C 25.331 10.941 23.536 10.747 21.494 10.747 C 19.56 10.747 17.776 10.962 16.185 11.403 C 15.154 10.167 13.348 8.598 10.747 8.598 C 9.221 11.048 9.844 13.692 10.425 15.175 C 9.264 16.798 8.598 18.883 8.598 21.494 C 8.598 27.577 11.414 30.855 17.045 31.876 C 16.325 32.575 15.766 33.424 15.422 34.391 L 12.897 34.391 C 11.349 34.391 10.747 33.703 9.92 32.585 C 9.092 31.468 8.2 30.715 7.136 30.404 C 6.567 30.339 6.18 30.801 6.685 31.21 C 8.372 32.424 8.49 34.412 9.167 35.713 C 9.78 36.884 11.048 37.615 12.477 37.615 L 15.046 37.615 L 15.046 42 C 6.319 39.27 0 31.124 0 21.494 C 0 9.619 9.619 0 21.494 0 C 33.37 0 42.989 9.619 42.989 21.494 Z",
    transform: "scale(0.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.135e183b7f37d5dbc0a8605c8d7f25d9.svg";
export { ForwardRef as ReactComponent };